module.exports = __webpack_public_path__ + "img/jingyin.fw.94799cc6.png";